import React from 'react';
import { Stack } from '@mui/material';
import { VTypography } from '@venti-components';
import PageContainer from '../../../Components/PageContainer/PageContainer';
import VBreadcrumbs from '../../../Venti-UI-Kit/VBreadcrumbs/VBreadcrumbs';
import { useArtistManagementPage } from './hook';
import ArtistCard from './ArtistCard/ArtistCard';
import BackofficePageTitle from '../../../Components/BackofficePageTitle/BackofficePageTitle';
import VAutocomplete from '../../../Venti-UI-Kit/VAutocomplete/VAutocomplete';
import AutocompleteOption from './AutocompleteOption/AutocompleteOption';

const ArtistManagementPage = ({ urlParams }) => {
  const { eventId } = urlParams;
  const { artists, loading, event, removeArtist, addArtist, searchArtist } =
    useArtistManagementPage(eventId);

  if (loading || !artists) {
    return (
      <PageContainer title="Backoffice - Artistas">
        <VBreadcrumbs pageTitle="Artistas" />
        <VTypography variant="body1">Cargando artistas...</VTypography>
      </PageContainer>
    );
  }

  return (
    <PageContainer title="Backoffice - Artistas">
      <VBreadcrumbs pageTitle="Artistas" />
      <Stack maxWidth={900} width="100%" gap={2} alignSelf="center" p={2}>
        <BackofficePageTitle
          mainTitle={event?.name}
          secondaryTitle="Agregá o eliminá artistas de tu evento"
        />
        <VAutocomplete
          optionLabelKey="name"
          onSelectOption={addArtist}
          searchFunction={searchArtist}
          placeholder="Buscar artista"
          noOptionsText="No se encontraron artistas con ese nombre."
          loadingText="Buscando artistas..."
          customOptionComponent={AutocompleteOption}
        />
        <Stack gap={1.5}>
          {artists.map((artist) => (
            <ArtistCard key={artist.id} artist={artist} onRemove={() => removeArtist(artist.id)} />
          ))}
          {artists.length === 0 && (
            <VTypography variant="body1">No hay artistas para este evento.</VTypography>
          )}
        </Stack>
      </Stack>
    </PageContainer>
  );
};

export default ArtistManagementPage;
